import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Modal } from 'react-bootstrap'

import { GET, POST, httpOk } from 'helpers/api'
import { formatDate } from 'helpers/helpers'

const timeOnly = (dt) => (dt ? formatDate(dt, 'HH:mm') : '—')

/**
 * E'tibor talab qiladigan kunlar: chiqish vaqti yozilmagan yoki xato kiritilgan.
 * Shu yerning o'zida to'g'ri vaqtni qo'yish mumkin — alohida sahifaga o'tish shart emas.
 */
function ReviewModal({ show, month, onClose, onSaved }) {
	const { t } = useTranslation()
	const [rows, setRows] = useState([])
	const [edits, setEdits] = useState({})   // { [id]: 'HH:mm' }
	const [busy, setBusy] = useState(null)
	const [loading, setLoading] = useState(false)

	async function load() {
		setLoading(true)
		const res = await GET('/attendance/needs-review', { month }, { loader: false })
		if (httpOk(res)) {
			setRows(res.data.data)
			setEdits({})
		}
		setLoading(false)
	}

	useEffect(() => {
		if (show) load()
	}, [show, month]) // eslint-disable-line react-hooks/exhaustive-deps

	async function saveRow(row) {
		const time = edits[row.id]
		if (!time) return

		const wd = String(row.work_date).slice(0, 10)
		setBusy(row.id)
		const res = await POST('/attendance', {
			employee_id: row.employee_id,
			work_date: wd,
			// Kirish vaqtini o'zgartirmaymiz — store() ikkala ustunni ham yozadi,
			// shuning uchun mavjud qiymatni qaytarib yuborish SHART.
			check_in_at: row.check_in_at,
			check_out_at: `${wd} ${time}:00`,
			status: 'present',
			note: row.note || '',
		}, { loader: false })
		setBusy(null)

		if (httpOk(res)) {
			await load()
			if (onSaved) onSaved()
		}
	}

	return (
		<Modal show={show} animation={false} centered size="lg" backdrop="static" onHide={onClose}>
			<Modal.Header closeButton>
				<Modal.Title style={{ fontSize: '17px' }}>
					{t('needs_review')}
					<span className="text-muted ms-2" style={{ fontSize: '13px', fontWeight: 400 }}>
						{formatDate(month + '-01', 'MM.yyyy')}
					</span>
				</Modal.Title>
			</Modal.Header>

			<Modal.Body>
				<p className="text-muted" style={{ fontSize: '12.5px' }}>
					{t('needs_review_hint')}
				</p>

				{loading && <div className="text-center text-muted py-4">{t('loading')}</div>}

				{!loading && rows.length === 0 &&
					<div className="text-center py-4">
						<i className="uil-check-circle" style={{ fontSize: 34, color: '#198754' }}></i>
						<div className="text-muted mt-1">{t('all_good_no_review')}</div>
					</div>
				}

				{!loading && rows.length > 0 &&
					<div className="table-responsive" style={{ maxHeight: '55vh' }}>
						<table className="table table-sm align-middle mb-0" style={{ fontSize: '13px' }}>
							<thead>
								<tr className="text-muted" style={{ fontSize: '12px' }}>
									<th style={{ position: 'sticky', top: 0, background: '#f8f9fa' }}>{t('employee')}</th>
									<th style={{ position: 'sticky', top: 0, background: '#f8f9fa' }}>{t('date')}</th>
									<th style={{ position: 'sticky', top: 0, background: '#f8f9fa' }} className="text-center">{t('check_in')}</th>
									<th style={{ position: 'sticky', top: 0, background: '#f8f9fa' }} className="text-center">{t('status')}</th>
									<th style={{ position: 'sticky', top: 0, background: '#f8f9fa', width: '30%' }} className="text-center">{t('check_out_time')}</th>
								</tr>
							</thead>
							<tbody>
								{rows.map((r) => (
									<tr key={r.id}>
										<td className="fw-semibold">{r.employee_name}</td>
										<td className="text-nowrap">{formatDate(r.work_date, 'dd.MM')}</td>
										<td className="text-center">{timeOnly(r.check_in_at)}</td>
										<td className="text-center">
											{r.invalid_times
												? <span className="badge bg-danger" style={{ fontSize: '10.5px' }}>{t('invalid_time')}</span>
												: <span className="badge bg-warning text-dark" style={{ fontSize: '10.5px' }}>{t('no_checkout')}</span>}
										</td>
										<td>
											<div className="d-flex gap-1">
												<input type="time" className="form-control form-control-sm"
													value={edits[r.id] || ''}
													onChange={(e) => setEdits({ ...edits, [r.id]: e.target.value })} />
												<button className="btn btn-sm btn-primary text-nowrap"
													disabled={!edits[r.id] || busy === r.id}
													onClick={() => saveRow(r)}>
													{busy === r.id ? '...' : t('save')}
												</button>
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				}

				<div className="d-flex justify-content-end mt-3">
					<button type="button" className="btn btn-outline-secondary" onClick={onClose}>{t('close')}</button>
				</div>
			</Modal.Body>
		</Modal>
	)
}

export default ReviewModal
